import request from "../utils/request";
import { hostUrl } from "../utils/constant"
// 获取软件基本信息
export const getbaseinfo = (params) => {
  return request.get(`main/plat/v1/softmgr/getbaseinfo`, {
    params,
  });
};

export const deleteInfo = (params) => {
  return request.post(`main/plat/v1/softmgr/delete`, params);
};

// 编辑回调
export const editinfo = (params) => {
  return request.post(`main/plat/v1/softmgr/editinfo`, params);
};

// 删除软件
export const offShelveSoft = (params) => {
  return request.post(`/main/plat/v1/softmgr/editstatus`, params);
}
